var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Accordion, AccordionDetails, AccordionSummary, Avatar, Box, Chip, Drawer, IconButton, Link, Typography, useMediaQuery, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { CallIcon } from 'hugeicons-react';
import { useState } from 'react';
import { RoleCategories } from '../../../../../../application/common/constants/role-categories';
import { TechnicianLevel } from '../../../../../../application/features/technicians/models/technician-level';
import { useAppSelector } from '../../../../../../application/store/useStore';
import useTranslate from '../../../../../../localization/helpers';
var RecentTechnicianDrawer = function (_a) {
    var matchingTechnicians = _a.matchingTechnicians, isRecentTechnicianDrawerOpen = _a.isRecentTechnicianDrawerOpen, setRecentTechnicianDrawerOpen = _a.setRecentTechnicianDrawerOpen;
    var theme = useTheme();
    var translate = useTranslate().translate;
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var isSm = useMediaQuery(theme.breakpoints.only('sm'));
    var currentUser = useAppSelector(function (state) { return state.auth; }).currentUser;
    var isSuperAdmin = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.roleCategory) === RoleCategories.SuperAdmin;
    var SPECIALITIES_PREVIEW_COUNT = 4;
    var _b = __read(useState({}), 2), expandedSpecialitiesByTechnicianId = _b[0], setExpandedSpecialitiesByTechnicianId = _b[1];
    var getTechnicianLevelText = function (level) {
        switch (level) {
            case TechnicianLevel.Junior:
                return translate('technicians.technicianLevels.junior');
            case TechnicianLevel.Senior:
                return translate('technicians.technicianLevels.senior');
            case TechnicianLevel.Service:
                return translate('technicians.technicianLevels.service');
            case TechnicianLevel.AllRound:
                return translate('technicians.technicianLevels.allRound');
        }
    };
    var onPhoneCall = function (phone) { return window.open("tel:".concat(phone)); };
    var handleCloseTechnicianDrawer = function () {
        setRecentTechnicianDrawerOpen(false);
    };
    return (_jsxs(Drawer, { slotProps: {
            paper: {
                sx: {
                    width: { sm: '375px', xs: '100%' },
                    height: { sm: 'calc(100vh - 24px)', xs: '100%' },
                    display: 'flex',
                    flexDirection: 'column'
                }
            }
        }, variant: 'temporary', anchor: isXs ? 'bottom' : isSm ? 'right' : 'right', open: isRecentTechnicianDrawerOpen, onClose: handleCloseTechnicianDrawer, children: [_jsx(Box, { sx: {
                    display: 'flex',
                    width: '100%',
                    gap: '8px',
                    flexDirection: 'column',
                    borderRadius: '16px',
                    padding: '16px 20px 16px 20px'
                }, children: _jsxs(Box, { display: 'flex', alignItems: 'center', flexDirection: 'row', justifyContent: 'space-between', children: [_jsx(Typography, { variant: 'h6', children: translate('chat.recentTechnicians') }), _jsx(IconButton, { size: 'small', onClick: handleCloseTechnicianDrawer, children: _jsx(CloseIcon, {}) })] }) }), _jsx(Box, { sx: { px: '20px', pb: 2, flex: 1, overflowY: 'auto' }, children: _jsx(Box, { padding: '16px 0px 16px 0px', gap: 2, borderRadius: '24px', display: 'flex', flexDirection: 'column', children: matchingTechnicians.map(function (technician) {
                        var _a;
                        return (_jsxs(Accordion, { disableGutters: true, sx: {
                                boxShadow: '0 12px 24px -4px #919EAB29',
                                borderRadius: '12px',
                                overflow: 'hidden',
                                '&:before': { display: 'none' }
                            }, children: [_jsx(AccordionSummary, { expandIcon: ((_a = technician.specialities) === null || _a === void 0 ? void 0 : _a.length) ? _jsx(ExpandMoreIcon, {}) : null, sx: {
                                        px: 1,
                                        '& .MuiAccordionSummary-content': { my: 0.5 }
                                    }, children: _jsxs(Box, { display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', minWidth: 0, gap: 1, children: [_jsxs(Box, { display: 'flex', flexDirection: 'row', gap: 1, sx: { flex: 1, minWidth: 0 }, alignItems: 'center', children: [_jsx(Avatar, { variant: 'circular', sizes: 'medium', alt: technician.fullName, src: technician.fullName }), _jsxs(Box, { display: 'flex', flexDirection: 'column', sx: { flex: 1, minWidth: 0 }, children: [_jsx(Typography, { sx: {
                                                                    whiteSpace: 'nowrap',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis'
                                                                }, variant: 'body1', children: technician.fullName }), _jsx(Typography, { variant: 'caption', fontSize: 12, color: '#454F5B', children: getTechnicianLevelText(technician.level) }), isSuperAdmin && (_jsx(Typography, { sx: {
                                                                    whiteSpace: 'nowrap',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis'
                                                                }, variant: 'caption', fontSize: 12, color: '#454F5B', children: technician.companyName }))] })] }), _jsx(IconButton, { size: 'medium', color: 'primary', onClick: function (e) {
                                                    e.stopPropagation();
                                                    onPhoneCall(technician.phoneNumber);
                                                }, children: _jsx(CallIcon, {}) })] }) }), _jsx(AccordionDetails, { sx: { pt: 0, pb: 1, px: 1.5 }, children: (function () {
                                        var _a, _b;
                                        var allSpecialities = (_a = technician.specialities) !== null && _a !== void 0 ? _a : [];
                                        if (!allSpecialities.length)
                                            return (_jsx(Typography, { variant: 'caption', color: '#454F5B', sx: { display: 'block', my: 1.5 }, children: translate('technicians.noSpecialities') }));
                                        var isExpanded = (_b = expandedSpecialitiesByTechnicianId[technician.id]) !== null && _b !== void 0 ? _b : false;
                                        var visibleSpecialities = isExpanded
                                            ? allSpecialities
                                            : allSpecialities.slice(0, SPECIALITIES_PREVIEW_COUNT);
                                        var remainingCount = allSpecialities.length - visibleSpecialities.length;
                                        var canToggle = allSpecialities.length > SPECIALITIES_PREVIEW_COUNT;
                                        return (_jsxs(Box, { my: 1.5, display: 'flex', flexDirection: 'column', gap: 1, children: [_jsx(Box, { display: 'flex', flexWrap: 'wrap', gap: 1, children: visibleSpecialities.map(function (speciality) { return (_jsx(Chip, { label: speciality.specialityName, size: 'medium', color: 'primary', variant: 'soft' }, speciality.specialityId)); }) }), canToggle && remainingCount > 0 && !isExpanded && (_jsxs(Link, { href: '#', underline: 'always', variant: 'body2', sx: { display: 'inline-block' }, onClick: function (e) {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        setExpandedSpecialitiesByTechnicianId(function (prev) {
                                                            var _a;
                                                            return (__assign(__assign({}, prev), (_a = {}, _a[technician.id] = true, _a)));
                                                        });
                                                    }, children: ["+", remainingCount, " ", translate('common.more')] })), canToggle && isExpanded && (_jsx(Link, { href: '#', underline: 'always', variant: 'body2', sx: { display: 'inline-block' }, onClick: function (e) {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        setExpandedSpecialitiesByTechnicianId(function (prev) {
                                                            var _a;
                                                            return (__assign(__assign({}, prev), (_a = {}, _a[technician.id] = false, _a)));
                                                        });
                                                    }, children: translate('common.showLess') }))] }));
                                    })() })] }, technician.id));
                    }) }) })] }));
};
export default RecentTechnicianDrawer;
